import { decodeBase64Url, encodeBase64Url, randomBytes } from './primitives';

export interface SedrGuestFragment {
  v: 1;
  /** Proof seed (base64url) */
  ps: string;
  /** Direct guest wrap key when passwordMode is None */
  gw?: string;
  /** Password salt when passwordMode is UserSet */
  salt?: string;
}

const FRAGMENT_SESSION_KEY = 'shareweb:sedrFragment:';

export function buildSedrGuestFragment(fragment: SedrGuestFragment | Uint8Array): string {
  const payload: SedrGuestFragment = fragment instanceof Uint8Array
    ? { v: 1, ps: encodeBase64Url(fragment) }
    : fragment;
  return encodeBase64Url(new TextEncoder().encode(JSON.stringify(payload)));
}

export function resolveSedrGuestFragment(roomToken: string): SedrGuestFragment | null {
  const hash = window.location.hash.replace(/^#/, '');
  if (hash) {
    const fragment = decodeFragment(hash);
    if (fragment) {
      sessionStorage.setItem(`${FRAGMENT_SESSION_KEY}${roomToken}`, JSON.stringify(fragment));
      history.replaceState(null, '', window.location.pathname + window.location.search);
      return fragment;
    }
  }

  const cached = sessionStorage.getItem(`${FRAGMENT_SESSION_KEY}${roomToken}`);
  if (!cached) return null;
  try {
    return JSON.parse(cached) as SedrGuestFragment;
  } catch {
    return null;
  }
}

/** @deprecated Prefer resolveSedrGuestFragment; kept for proof-seed-only callers */
export function resolveSedrGuestProofSeed(roomToken: string): Uint8Array | null {
  const fragment = resolveSedrGuestFragment(roomToken);
  return fragment?.ps ? decodeBase64Url(fragment.ps) : null;
}

function decodeFragment(hash: string): SedrGuestFragment | null {
  try {
    const json = new TextDecoder().decode(decodeBase64Url(hash));
    const fragment = JSON.parse(json) as SedrGuestFragment;
    if (fragment.v !== 1 || !fragment.ps) return null;
    return fragment;
  } catch {
    return null;
  }
}

export function generateSedrGuestProofSeed(): Uint8Array {
  return randomBytes(32);
}
